import { NoneSelected } from './none-selected/NoneSelected';
import { EditCarparks } from './edit-carparks/EditCarparks';
import { assembleParkingLocations } from '../parking/utils';
import MultipleCarparks from './multiple-carparks/MultipleCarparks';
import { SingleCarpark } from './single-carpark/SingleCarpark';
import { groupCarparks } from './utils/group-carparks';

export const ClaytonParking = ({
  widgetId,
  escapeSettingActionsFocusRef,
  data,
  updateData,
  editActiveWidget,
  parkingAvailability,
}) => {
  const selectedCarparks = data?.selectedCarparks || [];
  const hasSelectedCarparks = Boolean(selectedCarparks.length);

  const assembledParkingLocations =
    assembleParkingLocations(parkingAvailability);

  const enrichedCarparks = selectedCarparks.map((carpark) => {
    return {
      ...carpark,
      ...assembledParkingLocations.find((location) => {
        return location.id === carpark.value;
      }),
    };
  });

  const groupedCarparks = groupCarparks(enrichedCarparks);

  return (
    <>
      {hasSelectedCarparks ? (
        <div>
          {selectedCarparks.length === 1 ? (
            <SingleCarpark carpark={enrichedCarparks[0]} />
          ) : (
            <MultipleCarparks groupedCarparks={groupedCarparks} />
          )}
        </div>
      ) : (
        <NoneSelected widgetId={widgetId} />
      )}

      {editActiveWidget === widgetId && (
        <EditCarparks
          escapeFocusRef={escapeSettingActionsFocusRef}
          initialCarparks={selectedCarparks}
          assembledParkingLocations={assembledParkingLocations}
          updateData={updateData}
        />
      )}
    </>
  );
};
